import { UsuarioLogado } from "@/contexts/autorizacao/usuario/model/UsuarioLogado";
import { api } from "@/shared/api/api";

export const createUsuarioApi = (accessToken?: string) => {
  const headers = { Authorization: `Bearer ${accessToken}` };

  const getMe = async () => {
    const { data } = await api.get<UsuarioLogado>(`/usuarios/me`, { headers });
    return data;
  };

  return { getMe };
};
